import React from 'react';
import { MuiButton } from '@ui/base_library';
import { ButtonProps } from '@mui/material/Button';
import LoadingIcon from '../../../LoadingIndicators/CircularLoader';

export interface PrimaryButtonProps extends ButtonProps {
  loading?: boolean;
  // used in conjunction with the href prop
  target?: '_blank' | '_top' | '_self' | '_parent';
}

const PrimaryButton = React.forwardRef<HTMLButtonElement, PrimaryButtonProps>(
  ({ children, loading, disabled, ...props }, ref) => {
    return (
      <MuiButton
        data-variant="primary"
        disabled={loading || disabled}
        variant="contained"
        color="primary"
        {...props}
        ref={ref}
      >
        {loading ? <LoadingIcon /> : children}
      </MuiButton>
    );
  }
);

export default PrimaryButton;
